import { CustomerVatValidationStatus } from '@edgebox/data-definitions';
import React from 'react';
import { Badge, BadgeBg } from '@edgebox/react-components';
import { DataDefinitionsEnumValue } from '../../Localization/DataDefinitionsEnumValue';

interface IProps {
  status: CustomerVatValidationStatus;
  size?: 'small';
}

export class VatValidationStatusBadge extends React.Component<IProps, {}> {
  render(): React.ReactElement {
    const { status, size } = this.props;

    const classes = size ? 'small' : '';

    const variants: Record<string, BadgeBg> = {
      [CustomerVatValidationStatus.Approved]: 'success',
      [CustomerVatValidationStatus.AutomaticValidationPending]: 'warning',
      [CustomerVatValidationStatus.ManualValidationPending]: 'warning',
      [CustomerVatValidationStatus.Declined]: 'danger',
    };

    return (
      <Badge bg={variants[status]} className={classes}>
        <DataDefinitionsEnumValue enumName={'CustomerVatValidationStatus'} keyName={status} />
      </Badge>
    );
  }
}
